const cache = new Map();

function loadReviews(url) {
  if (!cache.has(url)) cache.set(url, fetch(url).then((res) => res.json()));
  return cache.get(url);
}

function summarize(reviews) {
  const counts = [0, 0, 0, 0, 0];
  let total = 0;
  for (const review of reviews) {
    counts[review.r - 1] += 1;
    total += review.r;
  }
  return { count: reviews.length, average: reviews.length ? total / reviews.length : 0, counts };
}

function stars(rating) {
  const full = Math.round(rating);
  return '★'.repeat(full) + '☆'.repeat(5 - full);
}

class StoreReviews extends HTMLElement {
  async connectedCallback() {
    this.pageSize = parseInt(this.dataset.pageSize, 10) || 6;
    this.shown = 0;
    try {
      const reviews = await loadReviews(this.dataset.src);
      this.summary = summarize(reviews);
      this.withText = reviews.filter((review) => review.m);
      this.renderSummary();
      this.renderMore();
      this.querySelector('[data-reviews-more]')?.addEventListener('click', () => this.renderMore());
      this.hidden = false;
    } catch (error) {
      console.warn('[store-reviews] Could not load reviews', error);
    }
  }

  renderSummary() {
    const { count, average, counts } = this.summary;
    const avgEl = this.querySelector('[data-reviews-average]');
    const starsEl = this.querySelector('[data-reviews-stars]');
    const countEl = this.querySelector('[data-reviews-count]');
    if (avgEl) avgEl.textContent = average.toFixed(1);
    if (starsEl) {
      starsEl.textContent = stars(average);
      starsEl.setAttribute('aria-label', `${average.toFixed(1)} / 5`);
    }
    if (countEl) countEl.textContent = String(count);

    const bars = this.querySelector('[data-reviews-bars]');
    if (!bars) return;
    bars.innerHTML = '';
    for (let rating = 5; rating >= 1; rating -= 1) {
      const n = counts[rating - 1];
      const row = document.createElement('li');
      row.className = 'store-reviews__bar';
      row.innerHTML = `<span>${rating}★</span><span class="store-reviews__track"><span style="width:${count ? (n / count) * 100 : 0}%"></span></span><span>${n}</span>`;
      bars.append(row);
    }
  }

  renderMore() {
    const list = this.querySelector('[data-reviews-list]');
    const more = this.querySelector('[data-reviews-more]');
    if (!list) return;
    const locale = this.dataset.locale || undefined;
    const format = new Intl.DateTimeFormat(locale, { month: 'short', year: 'numeric' });
    const next = this.withText.slice(this.shown, this.shown + this.pageSize);
    for (const review of next) {
      const card = document.createElement('li');
      card.className = 'store-reviews__card';
      const starsEl = document.createElement('p');
      starsEl.className = 'store-reviews__card-stars';
      starsEl.textContent = stars(review.r);
      starsEl.setAttribute('aria-label', `${review.r} / 5`);
      const text = document.createElement('p');
      text.className = 'store-reviews__text';
      text.textContent = review.m;
      const meta = document.createElement('p');
      meta.className = 'store-reviews__meta';
      meta.textContent = `${review.n} · ${format.format(new Date(review.d + 'T12:00:00'))}`;
      card.append(starsEl, text, meta);
      list.append(card);
    }
    this.shown += next.length;
    if (more) more.hidden = this.shown >= this.withText.length;
  }
}

class StoreRating extends HTMLElement {
  async connectedCallback() {
    try {
      const { count, average } = summarize(await loadReviews(this.dataset.src));
      if (!count) return;
      const starsEl = this.querySelector('[data-rating-stars]');
      const textEl = this.querySelector('[data-rating-text]');
      if (starsEl) starsEl.textContent = stars(average);
      if (textEl) textEl.textContent = `${average.toFixed(1)} (${count})`;
      this.setAttribute('aria-label', `${average.toFixed(1)} / 5, ${count}`);
      this.hidden = false;
    } catch (error) {
      console.warn('[store-rating] Could not load reviews', error);
    }
  }
}

if (!customElements.get('store-reviews')) customElements.define('store-reviews', StoreReviews);
if (!customElements.get('store-rating')) customElements.define('store-rating', StoreRating);
